import clsx from 'clsx';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import FaqCard from 'components/FaqCard';
import ImageWithFallback from 'components/ImageWithFallback';
import { giftCardFAQs, giftCardImages } from './content';
import styles from './referrals-faqs.module.css';

export const ReferralsFAQs = () => {
  return (
    <AboutUsModule background="tealGradient" extendBackgroundAbove>
      <AboutUsSiteContainer>
        <div className={styles.faqHeader}>
          <h2 className="aboutUsTypographyHeaderXlarge withPadding">FAQ's</h2>
        </div>
        <div className={styles.referralsFaqs}>
          <FaqCard
            preExpanded={true}
            rebrand2025
            question={'Where can I use my gift card?'}
            answer={
              <>
                <p>Your gift cards can be redeemed at brands like these:</p>
                <div className={styles.giftCardImages}>
                  {giftCardImages.map((img, i) => {
                    const mobileHide =
                      giftCardImages.length - 1 === i ||
                      giftCardImages.length - 2 === i;

                    return (
                      <div
                        key={`gift-card-faq-${i}`}
                        className={clsx(
                          styles.giftCardImage,
                          mobileHide && styles.hideOnMobile,
                        )}
                      >
                        <ImageWithFallback
                          src={img.image}
                          alt={img.name}
                          width={'100%'}
                          height={'100%'}
                        />
                      </div>
                    );
                  })}
                </div>
                <p className="aboutUsTypographyCaption">
                  *Brand availability may vary from time to time
                </p>
              </>
            }
          />
          {giftCardFAQs.map((faq, index) => (
            <FaqCard
              key={index}
              rebrand2025
              question={faq[0]}
              answer={faq[1]}
            />
          ))}
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
